import type { ComboBoxOption } from "@dealer-center/core-components";

export const getSelectedOnChange = (event: {
  target: {
    value?: ComboBoxOption | ComboBoxOption[];
  };
}) => {
  if (!event.target.value) return;
  if (!Array.isArray(event.target.value)) {
    if (typeof event.target.value === "string") return event.target.value;
    return event.target.value.value;
  }
  return event.target.value?.map(option => {
    if (typeof option === "string") return option;
    if (typeof event.target.value === "string") return event.target.value;
    return option.value;
  });
};
